import i18next from 'i18next';

i18next.addResources('es_CL', 'AddComments', {
  textareaPlaceholder: 'Solicita acá.',
  remainingCharacters: 'Quedan {{characters}} caracteres restantes.'
});
